import { render, staticRenderFns } from "./ProfilePictureAvatar.vue?vue&type=template&id=2a65c1ae&scoped=true&"
import script from "./ProfilePictureAvatar.vue?vue&type=script&lang=js&"
export * from "./ProfilePictureAvatar.vue?vue&type=script&lang=js&"
import style0 from "./ProfilePictureAvatar.vue?vue&type=style&index=0&id=2a65c1ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a65c1ae",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAvatar,VBtn,VIcon,VTooltip})
